import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import AppContext from '../AppContext';
import { DeleteFolderInput, DeleteFolderPayload } from './generated/types';

const mutation =
    `mutation MyMutation ($input: DeleteFolderInput! ) {
        deleteFolder(input: $input) {
          succeeded
        }
    }`;

export const useDeleteFolder = () => {
    const context = useContext(AppContext);

    return useMutation({
        mutationFn: async (folderInputs: DeleteFolderInput) => {
            const response = await (context.api.graphql({ query: mutation, variables: { input: folderInputs } }) as Promise<{
                data: {
                    deleteFolder: DeleteFolderPayload;
                };
            }>);

            return response.data.deleteFolder.succeeded;
        },
    });
};